import axios from "axios";

export const Axios = axios.create({
  baseURL: "https://apictarsa.tms.my.id/api/",
  //   baseURL: "https://api.tmsosial.asia/",
  timeout: 10000,
  headers: {},
});
